module.exports = __webpack_public_path__ + "static/beleserv-d679f3dedb3e1e55f53af38fcf304873.png";